module.exports = __webpack_public_path__ + "abc6dc038f74bdfac9f3203d58d85965.woff2";